import { isNativeApp } from './nativeAuth'

const SESSION_KEY = 'pairvelle_native_session'

export function getNativeSessionToken(): string | null {
  if (!isNativeApp()) return null
  try {
    return localStorage.getItem(SESSION_KEY)
  } catch {
    return null
  }
}

export function setNativeSessionToken(token: string | null): void {
  if (!isNativeApp()) return
  try {
    if (token) localStorage.setItem(SESSION_KEY, token)
    else localStorage.removeItem(SESSION_KEY)
  } catch {
    /* private mode / storage blocked */
  }
}
